import React, { useEffect, useState } from 'react';
import NoCarbonData from './NoCarbonData/NoCarbonData';
import TotalOcc from './TotalOcc/TotalOcc';
import TableOcc from './TableOcc/TableOcc';
import { getStartTimeProject } from '../../../../../utils/helpers';
import './CarbonCredits.scss';

const CarbonCredits = ({ stages, occData }) => {
  const [updatedByStagesData, setUpdatedByStagesData] = useState([]);
  const getDataTable = (arr, data) => ({
    ...arr,
    stage_date:
      `${getStartTimeProject(data.starts_at)
      } - ${
        getStartTimeProject(data.ends_at)}`,
  });
  useEffect(() => {
    const data = occData?.byStages.map((byStage) => {
      const correspondingStage = stages.find(
        (stage) => stage.stage_id === byStage.stage_id,
      );
      if (!correspondingStage) {
        return byStage;
      }
      return getDataTable(byStage, correspondingStage);
    });
    setUpdatedByStagesData(data);
  }, [occData]);
  const renderDataCarbon = () => (occData?.total || occData?.byStages.length ? (
    <div className="carbonCredits__wrapper">
      {occData?.total && <TotalOcc data={occData?.totalForAllStage} />}
      {occData?.byStages?.length && <TableOcc data={updatedByStagesData} />}
    </div>
  ) : (
    <NoCarbonData />
  ));
  return (
    <>
      {renderDataCarbon()}
    </>
  );
};

export default CarbonCredits;
